export const baseUnits = [
	{ value: 1, label: "g - cc" },
	{ value: 1000, label: "Kg - L" },
	{ value: 10000, label: "Tn - KL" },
];

export const baseFilterOrders = {
	page: 1,
	paginate: 10,
	order: "created_date",
	orderType: "desc",
	defaultUnitFilter: 1000,
	purchaseOrderDeliveryFilter: "",
	dateFilter: "",
	dateToFilter: "",
	showEmptyFilter: false,
	typeMovement: "",
};

export const table_head = [
	{
		name: "Razón Social",
		size: "10",
		order: "business_name",
	},
	{
		name: "Fecha Ingreso",
		size: "10",
		order: "created_date",
	},
	{
		name: "Tipo de Movimiento",
		size: "10",
		order: "origin_type",
	},
	{
		name: "Distribuidor",
		size: "10",
		order: "dealer_name",
	},
	{
		name: "delivery_text_numero",
		size: "12",
		order: "delivery_number",
	},
	{
		name: "Facturas Asociadas",
		size: "12",
		order: "",
	},
	{
		name: "Fecha Emisión",
		size: "10",
		order: "date_orders_delivery",
	},
	{
		name: "Cantidad Envases",
		size: "10",
		order: "created_date",
	},
	{
		name: "Costo Total",
		size: "13",
		order: "created_date",
	},
	{
		name: "Usuario",
		size: "5",
		order: "created_date",
	},
	{
		name: "Acción",
		size: "4",
		order: "",
	},
	{
		name: "",
		size: "4",
		order: "",
	},
];
